export const AnimatedLine = ({ showAnimation = false }) => {
    return (
        <svg
            key={showAnimation ? "animated" : "static"} // Принудительный перерендер
            width="550"
            height="98"
            viewBox="0 0 550 98"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                width: "600px",
                height: "auto",
                position: "absolute",
                zIndex: -1,
                margin: "40px auto",
            }}
        >
            {showAnimation ? (
                <defs>
                    <linearGradient
                        id="pulseGradient"
                        x1="-20%"
                        y1="0%"
                        x2="20%"
                        y2="0%"
                    >
                        <stop
                            offset="0%"
                            stopColor="#3E74FE"
                            stopOpacity="0.15"
                        />
                        <stop
                            offset="20%"
                            stopColor="#3E74FE"
                            stopOpacity="0.15"
                        />
                        <stop
                            offset="50%"
                            stopColor="#3E74FE"
                            stopOpacity="0.4"
                        />
                        <stop
                            offset="80%"
                            stopColor="#3E74FE"
                            stopOpacity="0.15"
                        />
                        <stop
                            offset="100%"
                            stopColor="#3E74FE"
                            stopOpacity="0.15"
                        />

                        <animate
                            attributeName="x1"
                            values="-20%;100%"
                            dur="2s"
                            repeatCount="1"
                        />
                        <animate
                            attributeName="x2"
                            values="20%;140%"
                            dur="2s"
                            repeatCount="1"
                        />
                    </linearGradient>
                </defs>
            ) : null}

            <path
                d="M4 67.1202C4 67.1202 55.5 4.99999 141.5 5C227.5 5.00001 321.5 59.5 413 64C505.5 60.8798 538 17.1202 538 17.1202"
                stroke={showAnimation ? "url(#pulseGradient)" : "#3E74FE"}
                strokeOpacity={showAnimation ? "1" : "0.15"}
                strokeWidth="8"
                fill="none"
                strokeDasharray={showAnimation ? "1000" : "none"}
                strokeDashoffset={showAnimation ? "1000" : "0"}
                style={{
                    animation: showAnimation ? "drawLine 2s ease-out forwards" : "none",
                    animationDelay: "300ms",
                }}
            />

            {showAnimation ? (
                <style>
                    {`
                        @keyframes drawLine {
                            to {
                                stroke-dashoffset: 0;
                            }
                        }
                    `}
                </style>
            ) : null}
        </svg>
    );
};
